<template>
<div class="chapter">
<div class="inner_page">
      ﻿ <title>Believing Jesus: Are You Willing to Risk Everything?: A Journey Through the Book of Acts</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="txc1" id="pz9-1"><i>I’ve pitched my tent in the land of hope.</i></p>
<p class="txc2" id="sec-8">—A<span class="small">CTS</span> 2:26 T<span class="small">HE</span> M<span class="small">ESSAGE </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?8efcd6e0